<template>
    <div :class="'alert alert-' + type" role="alert">
        <div class="row">
            <div class="col-12" v-if="title">
                <h4 class="alert-heading">{{ title }}</h4>
            </div>
            <div class="col-1 d-flex justify-content-center align-items-center">
                <i :class="getIconClass + ' text-' + type"></i>
            </div>
            <div class="col-11">
                <span v-if="message">
                    {{ message }}
                </span>
                <span v-if="actionUrl && actionText">
                    <br>
                    <a :href="actionUrl" class=" text-info">{{ actionText }}</a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Alert",
        props: ['type', 'title', 'message', 'actionUrl', 'actionText'],
        data() {
            return {
                icons: {
                    primary: "fas fa-info",
                    secondary: "fas fa-info",
                    success: "fas fa-check",
                    danger: "fas fa-times",
                    warning: "fas fa-times",
                    info: "fas fa-info",
                    light: "fas fa-info",
                    dark: "fal fa-exclamation-triangle"
                },
                iconClass: "fas fa-info"
            };
        },
        computed: {
            getIconClass() {
                return this.type ? this.icons[this.type] : this.icons.info;
            }
        }
    }
</script>

<style scoped>
    .alert {
        margin-top: 1rem;
    }

    .alert:hover {
        border: 1px solid transparent !important;
    }
</style>